import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'u box container storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'u box container storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>U-Box</span><span>Container Storage Services</span>',
  description:
    'Store and ship your belongings effortlessly with our trusted U-Box Container Storage solutions. Enjoy secure, flexible, and affordable storage services tailored to meet your needs.',
  image: {
    url: '/images/v2/pages/landing-pages/u-box-container-storage/hero-image.jpg',
    alt: 'Reliable U-Box Container Storage Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for U-Box Storage' }
}

export const ourProcessSectionContent = {
  title: 'How We Ensure Fast U-Box Storage Services',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/u-box-container-storage/how-we-ensure-fast-u-box-storage-services.png',
    alt: 'How We Ensure Fast U-Box Storage Services'
  },

  articles: [
    {
      id: 1,
      title: 'Effortless Booking and Pickup',
      description:
        'Schedule your U-Box Container Storage online with just a few clicks. Our team ensures a hassle-free pickup from your doorstep or desired location.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/effortless-booking-and-pickup.png',
        alt: 'Effortless Booking and Pickup'
      }
    },
    {
      id: 2,
      title: 'Organized Storage Solutions',
      description:
        'Your items are safely stored in climate-controlled facilities with advanced security systems, ensuring they remain in pristine condition throughout the storage period.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/organized-storage-solutions.png',
        alt: 'Organized Storage Solutions'
      }
    },
    {
      id: 3,
      title: 'Flexible and Reliable Shipping',
      description:
        "When you're ready, we deliver your belongings to your desired location promptly, making it easy to retrieve your stored items.",
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/flexible-and-reliable-shipping.png',
        alt: 'Flexible and Reliable Shipping'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable U-Box Container Storage',
  description:
    'Our U-Box Container Storage services are designed to offer budget-friendly solutions for storing and shipping your items. With transparent pricing, flexible durations, and customizable options, you’ll find the ideal storage plan that meets your specific needs.',
  image: {
    src: '/images/v2/pages/landing-pages/u-box-container-storage/affordable-u-box-container-storage.jpg',
    alt: 'Affordable U-Box Container Storage'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using U-Box Container Storage Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description: 'Save time and effort with doorstep pickup, easy scheduling, and seamless delivery options.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Security',
      description:
        'Our state-of-the-art facilities are equipped with 24/7 surveillance, climate control, and fire protection systems.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/security.png',
        alt: 'Security'
      }
    },
    {
      id: 3,
      title: 'Flexibility',
      description:
        'Choose from a range of box sizes, storage durations, and shipping options to fit your unique requirements.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/flexibility.png',
        alt: 'Flexibility'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for U-Box Container Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students',
          description: 'Store your belongings securely during breaks, semesters abroad, or transitions between dorms.'
        },
        {
          id: 2,
          title: 'Homeowners',
          description:
            'Perfect for decluttering, renovations, or storing seasonal items like holiday decorations and outdoor furniture.'
        },
        {
          id: 3,
          title: 'Businesses',
          description: 'Efficient solutions for storing inventory, excess office supplies, and promotional materials.'
        },
        {
          id: 4,
          title: 'Travelers',
          description: 'Safe and convenient storage for your luggage during extended trips or relocations.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/who-should-choose-us-for-u-box-container-storage-services.jpg',
        alt: 'Who Should Choose Us for U-Box Container Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Store and ship business inventory, documents, and equipment with our secure and efficient solutions tailored to business needs.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Relocating? Keep your belongings secure during your move, with reliable storage and seamless delivery to your new address.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Travel light! Store and ship your luggage safely, ensuring it’s ready when and where you need it.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Flexible storage for homeowners looking to declutter, renovate, or temporarily store household items.',
      image: {
        src: '/images/v2/pages/landing-pages/u-box-container-storage/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for U-Box Container Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/u-box-container-storage/why-choose-us-for-u-box-container-storage-services.jpg',
    alt: 'Why Choose Us for U-Box Container Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Cost-Effective Plans',
      description: 'Affordable rates for both short-term and long-term storage needs.'
    },
    {
      id: 2,
      title: 'Eco-Friendly Practices',
      description: 'We use sustainable materials and eco-conscious operations for a greener future.'
    },
    {
      id: 3,
      title: 'Secure Facilities',
      description: 'Advanced security features ensure the safety of your belongings.'
    },
    {
      id: 4,
      title: 'Customizable Options',
      description: 'Flexible storage plans with options for various box sizes and storage durations.'
    },
    {
      id: 5,
      title: 'Global Shipping Network',
      description: 'Reliable shipping to over 220 destinations, making international storage and shipping stress-free.'
    },
    {
      id: 6,
      title: 'Dedicated Support',
      description: 'Our team is available 24/7 to assist with booking, tracking, and answering any queries.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Exclusive U-Box Container Storage Services for Students',
  description:
    'U-Box container storage services for students. Fast, secure, and affordable solutions for storing and shipping your belongings easily and safely.',
  image: {
    src: '/images/v2/pages/landing-pages/u-box-container-storage/exclusive-u-box-container-storage-services-for-students.png',
    alt: 'Exclusive U-Box Container Storage Services for Students'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start U-Box Container Storage' }
}

export const ourPartnersSectionContent = {
  description:
    'At ShipAndStorage, we collaborate with industry-leading global carriers, including FedEx, DHL, and UPS, to offer top-notch shipping and storage solutions tailored to your needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Founded in 1971 by Frederick W. Smith, FedEx started with just 186 packages and has grown into a global shipping powerhouse. Operating a fleet of 696 aircraft and 215,000 vehicles, FedEx handles approximately 16 million shipments daily across more than 220 countries and territories. With over 550,000 employees and more than 5,000 global locations, FedEx is synonymous with reliability and efficiency.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 and is for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a key division of Deutsche Post DHL Group, is a global leader in international courier, parcel, and express mail services. With expertise in logistics, DHL manages over 1.8 billion parcels annually. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002. Operating in more than 220 countries, DHL plays a crucial role in connecting the global supply chain.',
        '<strong>Disclaimer:</strong> This page was last updated in September 2024 and is for reference only. DHL does not guarantee the accuracy of the information provided. For more details, visit <a href="https://www.dhl.com/global-en/home.html" target="_blank">DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved.'
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS, originally founded as the American Messenger Company in Seattle in 1907 by Claude Ryan and Jim Casey, rebranded to United Parcel Service (UPS) in 1919. Today, UPS is one of the world’s largest shipping companies, delivering around 25 million packages daily. With a global workforce exceeding 500,000 employees, UPS serves more than 220 countries and territories, ensuring seamless shipping services.',
        '<strong>Disclaimer:</strong> This page was last updated in September 2024 and is for reference only. UPS does not guarantee the accuracy of the information provided. For more details, visit <a href="https://www.ups.com/" target="_blank">UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved.'
      ]
    }
  ]
}
